module.exports = __webpack_public_path__ + "img/b_intro_1_en.1f36756.png";